let cleanup = () => {};

export function initializeMobileMenu() {
  cleanup();

  const button = document.querySelector(".menu-toggle");
  const panel = document.querySelector(".mobile-panel");
  if (!button || !panel) return;

  function setOpen(open) {
    panel.classList.toggle("open", open);
    button.classList.toggle("is-open", open);
    document.body.classList.toggle("mobile-menu-open", open);
    button.setAttribute("aria-expanded", String(open));
    button.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  }

  const toggle = () => setOpen(!panel.classList.contains("open"));
  const closeOnLink = (event) => {
    if (event.target.closest("a")) setOpen(false);
  };
  const closeOnEscape = (event) => {
    if (event.key === "Escape") setOpen(false);
  };

  setOpen(false);
  button.addEventListener("click", toggle);
  panel.addEventListener("click", closeOnLink);
  document.addEventListener("keydown", closeOnEscape);

  cleanup = () => {
    button.removeEventListener("click", toggle);
    panel.removeEventListener("click", closeOnLink);
    document.removeEventListener("keydown", closeOnEscape);
    document.body.classList.remove("mobile-menu-open");
  };
}
